import { Col, Row } from "reactstrap";
import { HeadingsTitle, ThisIsHeading } from "../../../Constants/Constants";

const Heading = () => {
  return (
    <section className="header-typography">
      <Row>
        <Col xs="12">
          <div className="element-card">
            <div className="element-card-header heading">
              <h2>{HeadingsTitle}</h2>
            </div>
            <div className="element-card-body typography">
              <h1>{ThisIsHeading}</h1>
              <h2>{ThisIsHeading}</h2>
              <h3>{ThisIsHeading}</h3>
              <h4>{ThisIsHeading}</h4>
              <h5>{ThisIsHeading}</h5>
              <h6>{ThisIsHeading}</h6>
            </div>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default Heading;
